import { useContext } from "react";
import { Thead, THT, THTS } from "../../components";
import TableContext from "../Provider/TableContext";

function TableHead() {
  const { setOrder = () => {} } = useContext(TableContext);

  return (
    <Thead>
      <THTS txt="Item Name" field="name" setOrder={setOrder} />
      <THTS txt="Quantity" field="quantity" setOrder={setOrder} />
      <THTS txt="Description" field="description" setOrder={setOrder} />
      <THTS txt="Status" field="status" setOrder={setOrder} />
      <THT txt="Actions" />
    </Thead>
  );
}

export default TableHead;
